<template>
<!--    <div class="search_item mb19">
        <div class="search_input detection_search_input">
            <el-input :placeholder="$t('st')" v-model="searchInput"
                      @input="setData('searchInput',searchInput)"
                      @keypress.native.enter="setFilterFunc(searchInputOption,searchInput)">
            </el-input>
            <button class="search_btn mypage_search_btn"  @click="setFilterFunc(searchInputOption,searchInput)"></button>
        </div>
        <button class="search_filter_btn" @click="openFilter('item-filter-interest-filter')"></button>
   <item-filter-interest-filter></item-filter-interest-filter>
    </div>-->
    <div class="competition_wrap pb17 padding_side">
        <div class="competition_item mypage_filter_item">
            <div class="competition_input">
                <el-input :placeholder="`${$t('st')}`" v-model="searchInput"
                          @input="setData('searchInput',searchInput)"
                          @keypress.native.enter="setFilterFunc(searchInputOption,searchInput)"></el-input>
                <button class="competition_btn" @click="setFilterFunc(searchInputOption,searchInput)"></button>
            </div>
        </div>
        <div class="competition_btn_wrap">
            <button class="c_filter_btn" @click="openFilter('item-filter-interest-filter')"></button>
            <!--썸네일 원 아이콘-->
            <button class="c_filter_thumnail_btn btn_thumb_one"
                    v-show=" listChange === 'thumbnail_one'"
                    @click="listTypeChange('thumbnail_two')"></button>
            <!--썸네일 투 아이콘      -->
            <button class="c_filter_thumnail_btn"
                    v-show=" listChange === 'thumbnail_two'"
                    @click="listTypeChange('thumbnail_one')"></button>
        </div>
        <div class="clear"></div>
        <item-filter-interest-filter></item-filter-interest-filter>
    </div>
</template>


<script>
import util from "@/mixins/util";
import itemUtil from "@/components/item/itemUtil";
import ItemFilterInterestFilter from "@/components/filter/ItemFilterInterestFilter";
import EventBus from "@/utils/event-bus";

const {filterConfig} = itemUtil
export default {
    name: "ItemFilterInterestLayout",
    mixins: [itemUtil],
    components: {ItemFilterInterestFilter},
    inject: ['setFilter', 'setSort'],
    provide() {
        return {}
    },
    props: {
        filterData: {
            default: () => {
            }
        },
    },

    data() {
        return {
            searchInputOption: 'ina',
            searchInput: '',
            filterCategory: [],
            filterStatus: [],
            filterEdition: [],
            filterType: [],
            statusArr: [],
            listChange: 'thumbnail_one',
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.setterFilterDataInData();
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        openFilter(name) {
            this.$modal.show(name, {filterData: this.filterData});
        },
        setterFilterDataInData() {
            let classnames = Object.keys(this.filterData);
            classnames.forEach(classname => {
                let obj = this.filterData[classname];
                let type = filterConfig[obj.key].type;
                if (this.hasOwnProperty(classname)) {
                    if (type == 'query') {
                        this[classname] = obj.query;
                        if (this.hasOwnProperty(classname + 'Option')) {
                            this[classname + 'Option'] = obj.key;
                        }
                    } else if (type === 'between') {
                        this[classname] = [obj.start, obj.end];
                    } else if (type === 'match') {
                        if (isNaN(obj.value)) {
                            this[classname] = obj.value;
                        } else {
                            this[classname] = Number(obj.value);
                        }

                    } else if (type === 'terms') {
                        this[classname] = obj.terms;
                    }

                }
            })
        },
        listTypeChange(type) {
            this.listChange = type;
            EventBus.$emit('changeListType', type);
        },
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },
        setData(key, value) {
            this[key] = value;
        },
        checkStatus(data) {
            this.filterStatus = [];
            util.Array.each(data, (status, index, storeSet) => {
                if (status === 1) {
                    this.filterStatus.push(1);
                    this.filterStatus.push(2);
                } else if (status === 2) {
                    this.filterStatus.push(3);
                } else if (status === 3) {
                    this.filterStatus.push(4);
                    this.filterStatus.push(5);
                } else if (status === 4) {
                    this.filterStatus.push(7);
                    this.filterStatus.push(8);
                    this.filterStatus.push(9);

                } else if (status === 5) {
                    this.filterStatus.push(6);
                }
            })
            this.setFilterFunc('imst', this.filterStatus)
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
